<template>
  <el-table
    :data="roles"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="id"
      label="#"
      fixed
      width="50"
    />
    <el-table-column
      prop="name"
      label="Név"
      sortable
      fixed
      :sort-method="sortByName"
    />
    <el-table-column
      prop="permissions"
      label="Jogosultságok"
      sortable
    >
      <template slot-scope="scope">
        <el-tooltip placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip">
          <div slot="content">
            <span v-if="scope.row.permissions.length">{{ scope.row.permissions.map(p => p.name).join(', ') }}</span>
            <span v-if="!scope.row.permissions.length">Nem tartozik jogosultság ehhez a jogkörhöz</span>
          </div>
          <el-tag>{{ scope.row.permissions.length }} jogosultság</el-tag>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column
      prop="users"
      label="Felhasználók"
      sortable
    >
      <template slot-scope="scope">
        <el-tooltip placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip">
          <div slot="content">
            <span v-if="scope.row.users.length">{{ scope.row.users.map(p => p.username).join(', ') }}</span>
            <span v-if="!scope.row.users.length">Nem tartozik felhasználó ehhez a jogkörhöz</span>
          </div>
          <el-tag>{{ scope.row.users.length }} felhasználó</el-tag>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column
      prop="created_at"
      sortable
      label="Létrehozva"
    >
      <template slot-scope="scope">
        {{ scope.row.created_at | dateTime }}
      </template>
    </el-table-column>
    <el-table-column
      prop="updated_at"
      sortable
      label="Módosítva"
    >
      <template slot-scope="scope">
        {{ scope.row.updated_at | dateTime }}
      </template>
    </el-table-column>
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template
        slot-scope="scope"
      >
        <Actions :role="scope.row"/>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Actions from './Actions';

export default {
  components: {
    Actions,
  },
  computed: {
    roles() {
      return this.$store.getters['role/roles'];
    },
    loading() {
      return this.$store.getters['role/loading'];
    },
  },
  async mounted() {
    await this.$store.dispatch('role/fetchAll');
  },
  methods: {
    sortByName(a, b) {
      if (a.name && b.name) {
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
      }
    },
    sortByUsername(a, b) {
      if (a.username && b.username) {
        return a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1;
      }
    },
  },
};
</script>

<style>
  .permission-info-tooltip {
    max-width: 300px;
  }
</style>
